import CountryComponent from '../../../../components/AdminSettings/Country';
import { CountryStyled } from './style';

const Country = () => {
  return (
    <CountryStyled>
      <CountryComponent />
    </CountryStyled>
  );
};

export default Country;
